import { useEffect, useState } from 'react';

import { getPageName } from 'utils/itineraries/functions/builderUtils';
import { useReactiveVar } from 'utils/reactivity';

import { EOrganizedBy } from '../../../structure';
import { useLandingV2Context } from '../../context';
import { EPageRole } from '../../Page/types';
import { ILink } from '../../TableOfContents/types';
import { getPrefix } from '../../utils';
import { useWebViewScroll } from './useWebViewScroll';

export const useNavigation = () => {
  useWebViewScroll();

  const { data, reactActivePageId, setActivePageId } = useLandingV2Context();
  const { scheduleType } = data;
  const activePageId = useReactiveVar(reactActivePageId);
  const links: ILink[] = data.landing.pages.map((p) => ({
    id: p.id,
    name: getPageName(p),
    navBarTitle: p.navBarTitle,
    builderTitle: p.builderTitle,
    sub: scheduleType === EOrganizedBy.Date && p.role == EPageRole.DAY ? p.subheadline : '',
    isHidden: p.hidden,
    onClick: (pageId) => {
      setActivePageId({ pageId, notifyExternalEnv: true, withScroll: true });
    },
  }));

  return { links, activePageId };
};

export const useHorizontalAutoScroll = (activePageId: number, links: ILink[]) => {
  const [activeIndex, setActiveIndex] = useState<number>(0);

  useEffect(() => {
    const index = links.findIndex((link) => link.id === activePageId);
    setActiveIndex(index);
  }, [activePageId, links]);

  useEffect(() => {
    const selector = getPrefix(NAVBAR_LINKS_CLASSNAME);
    const navigation = document.querySelector(`.${selector}`) as HTMLDivElement;
    const activeLink = navigation.children[activeIndex] as HTMLDivElement;
    const navigationWidth = navigation.offsetWidth;
    const activeLinkWidth = activeLink?.offsetWidth;
    const activeLinkLeft = activeLink?.offsetLeft;
    const activeLinkCenter = activeLinkLeft + activeLinkWidth / 2;
    const scrollLeft = activeLinkCenter - navigationWidth / 2;
    navigation.scrollTo({ left: scrollLeft, behavior: 'smooth' });
  }, [activeIndex]);

  return { setActiveIndex };
};

export const NAVBAR_LINKS_CLASSNAME = 'nav-bar-links';
